import { Action, createReducer, on } from '@ngrx/store';
import * as EndorsementActions from './endorsement.action';
import { EndorsementState, initialState } from './endorsement.state';

const endorsementReducer = createReducer(
  initialState,
  on(
    EndorsementActions.putEndorsements,
    (state, action: ReturnType<typeof EndorsementActions.putEndorsements>) => {
      const validEndorsements = action.payload.filter(
        endorsement => endorsement.RefContrat && endorsement.NumeroContrat
      );

      // Remplacer la liste existante par les avenants valides 
      const updatedEndorsements = [...validEndorsements];

      return {
        ...state,
        endorsements: updatedEndorsements
      };
    }
  )
);

export function reducer(state: EndorsementState | undefined, action: Action): EndorsementState {
  return endorsementReducer(state, action);
}
